export default "__VITE_ASSET__317232e2__$_?nuxt_component=async&nuxt_component_name=SvgoCheck__"